import {default as cx} from "classnames"
import {useState} from "react"
import {Modal} from "react-bootstrap"

import {getLocaleDate} from "../utilities/general"

export function OSRModal({osrs, orienteeName, hideTextAnswers, showWeek = false}) {
    const [showModal, setShowModal] = useState(false)
    const [osr, setOsr] = useState(osrs[0])

    const visibleAnswers = hideTextAnswers
        ? (osr.answers || []).filter((a) => a.question_type !== "text")
        : osr.answers || []
    const groupedAnswers = visibleAnswers.reduce((acc, answer) => {
        const category = answer.category || "Other"
        if (!acc[category]) acc[category] = []
        acc[category].push(answer)
        return acc
    }, {})

    return (
        <>
            <button className="btn btn-sm btn-light-primary px-5 me-2" onClick={() => setShowModal(true)}>
                OSR{osrs.length > 1 ? "s" : ""} {showWeek ? ` Week ${osr.week_of_orientation}` : ""}
            </button>
            {showModal && (
                <Modal
                    dialogClassName="modal-fullscreen modal-fullscreen-lg-down rounded-0"
                    show={!!osr}
                    onHide={() => setShowModal(false)}
                    animation={false}
                >
                    <Modal.Header closeButton closeVariant="white" className="modal-header">
                        <Modal.Title>
                            Orientee Status Report: Week {osr.week_of_orientation}
                            {osrs.length > 1 &&
                                osrs.map((report, index) => (
                                    <button
                                        key={index}
                                        className={cx(
                                            "ms-3 btn btn-sm",
                                            osr === report ? "btn-primary" : "btn-secondary"
                                        )}
                                        onClick={() => setOsr(report)}
                                    >
                                        {getLocaleDate(report.shift_date)}
                                    </button>
                                ))}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="app-default px-4">
                        <div className="d-flex flex-column justify-content-center flex-wrap me-3 ">
                            <h1 className="page-heading d-flex fw-bold fs-3 flex-column justify-content-center">
                                {orienteeName}
                            </h1>
                            <h1 className="page-heading d-flex fw-bold fs-3 flex-column justify-content-center mb-4">
                                Week {osr.week_of_orientation} OSR Scores
                                {osr.percent_of_max_osr_score != null && (
                                    <span className="fs-5 text-gray-600 fw-semibold mt-1">
                                        {osr.percent_of_max_osr_score}% &mdash; {osr.current_readiness_category}
                                    </span>
                                )}
                            </h1>
                        </div>
                        <div className="d-flex flex-column gap-3">
                            {Object.entries(groupedAnswers).map(([category, answers]) => (
                                <div key={category} className="border border-gray-300 rounded p-4">
                                    <div className="d-flex align-items-center mb-3">
                                        <h3 className="fs-5 mb-0 me-3">{category}</h3>
                                        {osr.category_scores?.[category] && (
                                            <div className="badge badge-light-primary">
                                                {osr.category_scores[category].percent}%
                                            </div>
                                        )}
                                    </div>
                                    {answers.map((answer) => (
                                        <div
                                            key={answer.question_id}
                                            className="d-flex justify-content-between align-items-start border-bottom py-2"
                                        >
                                            <span className="text-gray-700 pe-4">{answer.question}</span>
                                            <span className="fw-semibold text-end">
                                                {answer.selected
                                                    ? answer.selected.filter(Boolean).join(", ")
                                                    : (answer.answer ?? "—")}
                                            </span>
                                        </div>
                                    ))}
                                </div>
                            ))}
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className="btn btn-secondary" onClick={() => setShowModal(false)}>
                            Close
                        </button>
                    </Modal.Footer>
                </Modal>
            )}
        </>
    )
}
